import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface Permissions {
    userId: string,
    emailId: any,
    firstName: any,
    lastName: any,
    roleNames: any[],
    originalRole: any,
    isAuthorizedOfficer: any,
    isSystemAdministrator: any,
    cellphone: any

}

const initialState: Permissions = {
    userId: '',
    emailId: '',
    firstName: '',
    lastName: '',
    roleNames: ['ADMINISTRATOR'],
    originalRole: '',
    isAuthorizedOfficer: '',
    isSystemAdministrator: '',
    cellphone: ''

};

export const permissionsSlice = createSlice({
    name: 'permissions',
    initialState,
    reducers: {
        setPermissions(state, action: PayloadAction<any>) {
            state.firstName = action.payload.given_name;
            state.lastName = action.payload.family_name;
            state.emailId = action.payload.email;
            state.roleNames = action.payload.roleNames;
            state.originalRole = action.payload.origin_customer_role;
            state.userId = action.payload.userId;
            state.isAuthorizedOfficer = action.payload.is_authorized_officer;
            state.isSystemAdministrator = action.payload.is_system_administrator;
            state.cellphone = JSON.parse(action.payload.phone).cellphone || '';
        },
    },
});

export const permissionsActions = permissionsSlice.actions;
export type PermissionsSlice = {
    [permissionsSlice.name]: ReturnType<typeof permissionsSlice['reducer']>
};
